const appConfig = {
    authtoken: 'authtoken',
    authtoken_impersonate: 'authtoken_impersonate',
    socketUrl: window.location.origin.indexOf('localhost') > -1 ? 'http://localhost:8081' : window.location.origin,
    initialYear: 2016,
};

export default appConfig;



// WEBPACK FOOTER //
// ./source/config/app-config.js